import { TReturnType } from '@r1-frontend/service-engineer-visit';

import { IAction } from '~/src/store';

import { ESpeedBonusActions } from './constants';

export const setTimeSlotData = (data: TReturnType): IAction<ESpeedBonusActions.setTimeSlotData, TReturnType> => ({
    type: ESpeedBonusActions.setTimeSlotData,
    payload: data,
});
